const state = {
  filtersSaved: {},
};

const getters = {
  getFiltersSaved: st => () => {
    return st.filtersSaved;
  },
};

const mutations = {
  setFiltersSaved: (st, payload) => {
    st.filtersSaved = payload;
  },
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/filters.js